import React, { FC } from 'react';
import { useAtomValue } from 'jotai';
import cookiesPolicySrc from './docs/gb.md';
import Nav from '~/components/nav';
import MarkdownNode from '~/components/markdown-node';
import { $UserAgent } from '@lemon8/web-app-shared/atom';

export const PolicyBody: FC = () => {
  const { isMobile, isInApp } = useAtomValue($UserAgent);

  return (
    <>
      {!isInApp && <Nav />}
      <MarkdownNode isMobile={isMobile} isInApp={isInApp} src={cookiesPolicySrc} />
    </>
  );
};
